module.exports = __webpack_public_path__ + "img/custom-4.82871aff.svg";